<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Cancel plan</template>

    <Sheet.Body>
      <CancelPlanBody />
    </Sheet.Body>

    <div
      class="flex shrink-0 flex-col gap-2.5 px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]"
    >
      <Button variant="danger" size="lg" @click="handleConfirm">
        Cancel subscription
      </Button>
      <Button variant="stroke" size="lg" @click="close()">
        Keep subscription
      </Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import { openModal, Modals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'
import CancelPlanBody from './CancelPlanBody.vue'

const { close } = useSheet()

const handleConfirm = () => {
  closeAllSheets()
  openModal(Modals.ConfirmCancelPlan)
}
</script>
